// src/components/store/sections/hero-banner/HeroV91PanoramicwaveEmeraldMint.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV91PanoramicwaveEmeraldMint(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={91}
      archKey="panoramic_wave"
      archLabel="Panoramic Wave Showcase"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      {...props}
    />
  );
}
